import { Alert } from '@app-velocity/ui';

import { OpenIcon } from '@app-velocity/icons';
import { useI18n } from '@app-velocity/i18n';
import { useAppContext } from '@app-velocity/config';

import { useScenarioDetailsContext } from '../../../../hooks/useScenarioDetailsContext';
import { useAIReviewStatusContext } from '../../hooks/useAIReviewStatusContext';

export const ActionWebReport = () => {
  const { t } = useI18n();
  const { AVMLink } = useAppContext();
  const { review } = useAIReviewStatusContext();
  const { scenario } = useScenarioDetailsContext();

  const openWebReport = () => {
    window.open(`${AVMLink}/report/${scenario.shareToken}`);
  };

  if (
    !review.reviewStatus ||
    !['COMPLETED', 'CANCELED'].includes(review.reviewStatus)
  )
    return null;

  return (
    <Alert.ActionButton status="success" onClick={openWebReport}>
      {t('prototypes:open_web_report')}
      <OpenIcon />
    </Alert.ActionButton>
  );
};
